import React from 'react';
import styled from 'styled-components';

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  color: #000;
  width: 100vw;
  margin-left: -100px;


  @media (max-width: 762px) {
    width: unset;
    margin-left: -40px;
    margin-right: -40px;
    right: 0;
  }

   @media (min-height: 550px) {
    bottom: 0;
  }


  @media screen and (hover: none) and (orientation: landscape) {
    flex-direction: row;
    width: 50%;
    flex: 1;
    min-width: 0;
    margin-left: 0;
    margin-right: 0;
  }
`;

const InfoContainer = styled.div`
  background-color: transparent;
  padding: 40px 110px 0 110px;
  margin: -0.3em 0;
  border-top: 0.6em dotted #002636;
  border-bottom: 0.6em dotted #002636;

  div .col {
    margin-bottom: 2em;
  }


  @media (max-width: 762px) {
    padding: 20px;
  }

  @media screen and (hover: none) and (orientation: landscape) {
    width: 100%;
    padding: clamp(16px, 3vw, 40px);
    border-top: none;
    border-bottom: none;
    border-left: 0.6em dotted #002636;
  }
`;

const Border = styled.div`
  width: 100%;
  height: 0.3em;
  background-color: #002636;

  @media screen and (hover: none) and (orientation: landscape) {
    width: 0.3em;
    height: 100%;

    &.secondBorder {
      width: 0;
    }
  }
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const TicketContainer = ({ children }) => {
  return (
    <InfoBox>
      <Border />
      <InfoContainer>
        <MainContainer>
          {children}
        </MainContainer>
      </InfoContainer>
      <Border className="secondBorder"/>
    </InfoBox>
  );
};
export default TicketContainer;
